const apiMainProject = {
  // 03.08 分页查询重点工程附件
  getPageQueryProjectFile: '/api/ImportantProject/PageQueryProjectFile',
  // 03.07 上传重点工程附件
  goAddImportantProject: '/api/ImportantProject/UploadProjectFile',
}

export default apiMainProject
